
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiApplicationOpenGoogle as ObiApplicationOpenGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-application-open-google.js';
 
 
 

 
 export const ObiApplicationOpenGoogle = createComponent({
   react: React,
   tagName: 'obi-application-open-google',
   elementClass: ObiApplicationOpenGoogleElement,
   events: {
     
   }
  });
 
 